export const formatDateToIOS = (dateString: any): string => {
    // Handle different input types
    if (!dateString) return '';

    let date: Date;

    if (typeof dateString === 'string') {
        const parts = dateString.split('-');
        if (parts.length === 3) {
            if (parts[0].length === 4) {
                // YYYY-MM-DD format
                const year = parseInt(parts[0]);
                const month = parseInt(parts[1]) - 1; // months are zero-indexed in JavaScript
                const day = parseInt(parts[2]);
                date = new Date(year, month, day);
            } else {
                // MM-DD-YYYY format
                const year = parseInt(parts[2]);
                const month = parseInt(parts[0]) - 1; // months are zero-indexed in JavaScript
                const day = parseInt(parts[1]);
                date = new Date(year, month, day);
            }
        } else {
            // Fallback for other string formats
            date = new Date(dateString);
        }
    } else if (dateString instanceof Date) {
        date = dateString;
    } else {
        // Handle other types by converting to Date
        date = new Date(dateString);
    }

    // Format manually to avoid timezone conversion
    const formattedYear = date.getFullYear();
    const formattedMonth = String(date.getMonth() + 1).padStart(2, '0');
    const formattedDay = String(date.getDate()).padStart(2, '0');
    return `${formattedYear}-${formattedMonth}-${formattedDay}`;
}
export const parseDateISOFormat = (currentDate: any) => {
    if (!currentDate) return '';

    // Handle both Date objects and date strings
    let dateObj;
    if (typeof currentDate === 'string') {
      // Parse date string directly to avoid timezone issues
      const parts = currentDate.split('-');
      if (parts.length === 3) {
        const year = parseInt(parts[0]);
        const month = parseInt(parts[1]) - 1; // months are zero-indexed
        const day = parseInt(parts[2]);
        dateObj = new Date(year, month, day);
      } else {
        // Fallback to original parsing for other formats
        const iosCompatibleDate = currentDate.replace(/-/g, '/');
        dateObj = new Date(iosCompatibleDate);
      }
    } else if (currentDate instanceof Date) {
      dateObj = currentDate;
    } else {
      dateObj = new Date(currentDate);
    }

    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }